import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { cookiePlaceholderClickable, cookiePlaceholderText } from '../../../../cookiebar/cookiebar.layout'
import { cookiebarWidget, isCookieAccepted } from '../../../../cookiebar/cookiebar.widget'
import { DP } from '../../../drupal/blockDefinitions'
import { dummyData, randomTitle, randomWords } from '../../../utils/dummyData'
import { Iframe } from '../../../utils/iframe'
import { AnchorProps, ModernBlock, SeoEvent } from '../../modernBlocks.state'
import { iframeBlockClasses, IframeBlockLayout } from './iframeBlock.layout'

export type IframeBlockProps = {
  url: string
  embedCode: string
  embedCodeCheck: boolean
  width?: number | string
  height?: number
  useCookieBar: boolean
  label: string
  title: string
  disableCookieConcent?: boolean | undefined
  iframeTitle: string
  iframeType?: string
  introduction: string
} & AnchorProps

export const iframeBlock: ModernBlock<IframeBlockProps, any, DP.Iframe> = {
  kind: 'iframeBlock',
  render: (setRootState, rootState, blockIndex, blockProps) =>
    fromJSX((update_block) => (
      <IframeBlockLayout.Inner
        id={`iframeblock-${blockIndex}`}
      >
        <IframeBlockLayout.Content
          label={blockProps.label}
          title={blockProps.title}
          intro={blockProps.introduction}
        >
          {(blockProps.url || blockProps.embedCode) && (
            blockProps.useCookieBar && blockProps.url != '' && !isCookieAccepted('video-cookies') && !blockProps.disableCookieConcent ? (
              cookiebarWidget(
                rootState.cookiebarState,
                'video-cookies',
                cookiePlaceholderText('iframe'),
                cookiePlaceholderClickable('iframe')
              ).run((a_cs) => {
                setRootState((s1) => {
                  return { ...s1, cookiestate: a_cs(s1.cookiebarState) }
                })
              })
            ) : (
              <Iframe
                url={blockProps.url.trim()}
              ></Iframe>
            )
          )}
        </IframeBlockLayout.Content>
      </IframeBlockLayout.Inner>
    )),
  adapters: {
    drupal: (dp_block: DP.Iframe, blockIndex: number) => {
      const target = dp_block.target.type[0].target_id
      if (target != 'iframe') return undefined

      return {
        embedCode: '',
        excludeFromPageMenu: dp_block.target?.field_exclude_from_page_menu?.[0]?.value,
        label: dp_block.target.field_label[0]?.value,
        title: dp_block.target.field_title[0]?.value,
        iframeTitle: dp_block.target.field_iframe_title[0]?.value,
        introduction: dp_block.target.field_introduction[0]?.value,
        url: dp_block.target.field_link[0]?.processed_url,
        disableCookieConcent: dp_block.target?.field_disable_cookies?.[0]?.value,
        embedCodeCheck: false,
        useCookieBar: true,
        anchorTitle: `iframe-${blockIndex}`
      }
    }
  },
  sampleExample: [
    {
      useCookieBar: true,
      url: dummyData.video,
      embedCode: '',
      embedCodeCheck: false,
      width: 640,
      height: 420,
      anchorTitle: "iframe-sample-1",
      iframeTitle: "iframe title",
      iframeType: "iframe type",
      title: randomTitle(),
      label: randomWords(),
      introduction: dummyData.intro,
    }
  ],
  seoEvents: (_, blockIndex: number) => [
    {
      id: `iframe-wrapper`,
      event: 'onMouseOver',
      category: 'textblock-wrapper',
      label: window.location.pathname,
      action: 'click'
    } as SeoEvent
  ],
  inView: {
    threshold: 0.75,
    triggerOnce: false,
    inViewClassName: getClassNameModern(iframeBlockClasses, 'inview', 'inview'),
    showAs: 'section',
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState
      }
    }
  },
  blockClassName: getClassNameModern(iframeBlockClasses, 'block', 'mb-6')
}
